import { Button, Form, Input, Menu, Image, Popconfirm } from 'antd';
import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../../../contexts/AppContext';
import { GLOBAL_EVENT } from '../../../../consts/common/global-event';
import * as Icons from '@ant-design/icons';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

const Icon = ({ name }) => {
  const AntIcon = Icons[name];
  return AntIcon ? <AntIcon /> : null;
};

const ChatList: React.FC<any> = (props) => {
  const { menus } = props;
  const { selectSessionId, setSelectSessionId, color, setChatEvent } = useContext(AppContext);
  const [selectedKeys, setSelectedKeys] = useState<any>();
  const [openKeys, setOpenKeys] = useState<any>([]);
  const [searchText, setSearchText] = useState<any>(null);
  const [sessionName, setSessionName] = useState<any>(null);

  const menuOpenChangeHandler = (keys: string[]) => {
    setOpenKeys(keys);
  };

  const menuClickHandler = (menu: any) => {
    setSelectedKeys(menu.key);
    setSelectSessionId(Number(menu.key));
  };

  const findMenuDeep = (keys, menuItems) => {
    for (let index = 0; index < menuItems.length; index++) {
      const menu = menuItems[index];
      keys.push(menu.key);
      setOpenKeys(keys);
      if (menu.children && menu.children.length > 0) {
        findMenuDeep(keys, menu.children);
      }
    }
  };

  useEffect(() => {
    if (!menus) {
      return;
    }
    if (selectSessionId) {
      setTimeout(() => {
        setSelectedKeys(selectSessionId.toString());
      }, 500);
    }
    findMenuDeep([], menus);
  }, [menus]);

  useEffect(() => {
    if (!selectedKeys) {
      return;
    }
    for (let index = 0; index < menus.length; index++) {
      if (menus[index].children && menus[index].children.length > 0) {
        for (let i = 0; i < menus[index].children.length; i++) {
          if (menus[index].children[i].key.toString() === selectedKeys) {
            const eventInfo = {
              eventType: GLOBAL_EVENT.MENU_ITEM_CLICK,
              data: menus[index].children[i],
            };
            setChatEvent(eventInfo);
            break;
          }
        }
      }
    }
  }, [selectedKeys]);

  return (
    <>
      <>
        <Form name="basic" layout={'inline'} autoComplete="off" style={{ padding: '12px' }}>
          <Form.Item name={'search'} style={{ width: 'calc(100% - 65px)' }}>
            <Input
              placeholder="メニュー検索"
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
            />
          </Form.Item>

          <Button
            type="primary"
            onClick={() => {
              const eventInfo = {
                eventType: 'CREATE_CHAT_SESSION',
              };
              setChatEvent(eventInfo);
            }}
          >
            <Image width={16} preview={false} src={process.env.REACT_APP_DOMAIN + 'assets/icon_new_chat.svg'} />
          </Button>
        </Form>
      </>

      {menus ? (
        <>
          <Menu
            theme={color.theme}
            style={{
              paddingTop: 0,
              height: 'calc(100% - 84px)',
              background: color.layoutBackground,
            }}
            mode="inline"
            defaultSelectedKeys={[selectedKeys]}
            selectedKeys={[selectedKeys]}
            onSelect={menuClickHandler}
            items={(menus || []).map((item) => {
              return {
                ...item,
                icon: <Icon name={item.icon} />,
                children: (item.children || [])
                  .map((child, j) => {
                    child.label = (
                      <div className="chat-menu-item">
                        <span className="ellipsis" style={{ width: 150 }} title={child.name}>
                          {child.name}
                        </span>
                        <Popconfirm
                          title="Delete the chat history"
                          description={
                            <>
                              <div>Are you sure to remove this chat history?</div>
                            </>
                          }
                          onConfirm={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            const eventInfo = {
                              eventType: 'REMOVE_CHAT_SESSION',
                              data: child.key,
                            };
                            setChatEvent(eventInfo);
                          }}
                          onCancel={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                          okText="Yes"
                          cancelText="No"
                        >
                          <DeleteOutlined
                            className="remove-menu-item"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          />
                        </Popconfirm>
                        <Popconfirm
                          title="Edit session name"
                          description={
                            <>
                              <div>
                                <Input
                                  maxLength={20}
                                  placeholder="change session name"
                                  value={sessionName}
                                  onChange={(e) => {
                                    setSessionName(e.target.value);
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                  }}
                                />
                              </div>
                            </>
                          }
                          onConfirm={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (sessionName) {
                              const eventInfo = {
                                eventType: 'UPDATE_CHAT_SESSION',
                                data: { sessionId: child.key, name: sessionName },
                              };
                              setChatEvent(eventInfo);
                            }
                          }}
                          onCancel={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setSessionName(child.name);
                          }}
                          okText="Yes"
                          cancelText="No"
                        >
                          <EditOutlined
                            className="setting-menu-item"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setSessionName(child.name);
                            }}
                          />
                        </Popconfirm>
                      </div>
                    );
                    return child;
                  })
                  .filter((child) => {
                    if (!searchText || searchText.length === 0) {
                      return true;
                    } else {
                      return child.sessionId && child.name.includes(searchText);
                    }
                  }),
              };
            })}
            openKeys={openKeys}
            onOpenChange={menuOpenChangeHandler}
            className="search-menu custom-scrollbar"
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ChatList;
